import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { PaywallProps } from '@components/Paywall';
import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

import { Author } from '../../../interfaces/authors';
import { Article, MostPopularArticle } from '../../../interfaces/homepage';
import { ArticleOrBriefing } from '../../Feed/ArticleOrBriefingFeedItem';
import BriefingContent from './BriefingContent';

type BriefingPaywallProps = Omit<PaywallProps, 'articleId' | 'shareGuid' | 'trackingProps'>;

export interface BriefingType {
  authors?: Author[];
  body: string;
  commentCount: number;
  contentType: 'Briefing';
  createdAt: string;
  headline: string;
  id: number;
  slug: string;
  relatedItems?: ArticleOrBriefing[];
  source?: BriefingSource;
}

export interface BriefingSource {
  name: string;
  url: string;
}

export interface BriefingProps {
  briefing: BriefingType;
  canViewFullBriefing: boolean;
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isWebview: boolean;
  isSEOBot: boolean;
  mostPopularArticles: MostPopularArticle[];
  paywallProps?: BriefingPaywallProps;
  relatedArticles: Article[];
  teaser: string;
}

const queryClient = new QueryClient();

const Briefing = (props: BriefingProps) => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <BriefingContent {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Briefing;
